/* istanbul ignore file */
import { esriIdentityManager } from 'cd-eft/utils/esriTypes';
async function registerUrlTokensAsync(urlTokens: { url: string; token: string }[]) {
  for (const urlToken of urlTokens) {
    esriIdentityManager.registerToken({ server: urlToken.url, token: urlToken.token });
  }
}
export default registerUrlTokensAsync;
